import { combineReducers } from 'redux';
import {
    FETCH_ACCOUNT_IDENTITIES_REQUESTED,
    FETCH_ACCOUNT_IDENTITIES_SUCCEEDED,
    FETCH_ACCOUNT_IDENTITIES_FAILED,
    FETCH_DETAILED_IDENTITY_REQUESTED,
    FETCH_DETAILED_IDENTITY_SUCCEEDED,
    FETCH_DETAILED_IDENTITY_FAILED,
    FETCH_IDENTITIES_REQUESTED,
    FETCH_IDENTITIES_SUCCEEDED,
    FETCH_IDENTITIES_FAILED,
} from './actions';

const identity = (state = {}, action) => {
    switch(action.type) {
        case FETCH_ACCOUNT_IDENTITIES_SUCCEEDED:
        case FETCH_DETAILED_IDENTITY_SUCCEEDED:
        case FETCH_IDENTITIES_SUCCEEDED:
            return {
                ...state,
                ...action.payload,
                loading: false,
            };
        case FETCH_DETAILED_IDENTITY_REQUESTED:
        case FETCH_IDENTITIES_REQUESTED:
            return {
                ...state,
                loading: true,
            };
        case FETCH_DETAILED_IDENTITY_FAILED:
        case FETCH_IDENTITIES_FAILED:
            return {
                ...state,
                loading: false,
                errorMessage: action.payload,
            };
        default:
            return state;
    }
};

const byId = (state = {}, action) => {
    switch(action.type) {
        case FETCH_ACCOUNT_IDENTITIES_SUCCEEDED:
        case FETCH_DETAILED_IDENTITY_SUCCEEDED:
        case FETCH_IDENTITIES_SUCCEEDED: {
            const newState = { ...state };
            action.payload.forEach(it => {
                const identityAction = {
                    ...action,
                    payload: it,
                    meta: it.identityId
                };
                newState[it.identityId] = identity(state[it.identityId], identityAction);
            });
            return newState;
        }

        case FETCH_DETAILED_IDENTITY_REQUESTED:
        case FETCH_IDENTITIES_REQUESTED:
        case FETCH_DETAILED_IDENTITY_FAILED:
        case FETCH_IDENTITIES_FAILED: {
            const newState = { ...state };
            action.meta.forEach(it => {
                const identityAction = {
                    ...action,
                    meta: it
                };
                newState[it] = identity(state[it], identityAction);
            });
            return newState;
        }

        default:
            return state;
    }
};

const managedIds = (state = [], action) => {
    switch(action.type) {
        case FETCH_ACCOUNT_IDENTITIES_SUCCEEDED:
            return action.payload.map(it => it.identityId);
        default:
            return state;
    }
};

const fetchInProgress = (state = false, action) => {
    switch(action.type) {
        case FETCH_ACCOUNT_IDENTITIES_REQUESTED:
            return true;
        case FETCH_ACCOUNT_IDENTITIES_SUCCEEDED:
        case FETCH_ACCOUNT_IDENTITIES_FAILED:
            return false;
        default:
            return state;
    }
}

const errorMessage = (state = '', action) => {
    switch(action.type) {
        case FETCH_ACCOUNT_IDENTITIES_FAILED:
            if (action.error) {
                return action.error.message || 'An error occurred';
            }
            return 'An error occurred';
        case FETCH_ACCOUNT_IDENTITIES_REQUESTED:
        case FETCH_ACCOUNT_IDENTITIES_SUCCEEDED:
            return '';
        default:
            return state;
    }
}

export default combineReducers({
    byId,
    managedIds,
    fetchInProgress,
    errorMessage,
});

